import { Controller } from "@hotwired/stimulus"

// Per-row controller for the PO review screen. Manages the "what should
// we do with this line item?" workflow when the local + AI matchers
// couldn't pin the description to an existing product.
//
// Visibility rules:
//   - actionPanel shows ONLY when the product dropdown is empty
//     (the user is going to create something new, or skip the line).
//     If a real product is selected, the action is implicit ("use match")
//     and we hide the panel entirely.
//   - parentPanel shows ONLY when action == "add_variant".
//
// All wiring is data-attribute driven. Targets:
//   select         - the product_id <select> (already searchable)
//   actionPanel    - the wrapper containing the action selector + parent picker
//   actionSelect   - the action <select> (create_new / add_variant / skip)
//   parentPanel    - wrapper around the parent <select>
//   row            - the entire <tr> (gets dimmed when action = "skip")
export default class extends Controller {
    static targets = ["select", "actionPanel", "actionSelect", "parentPanel", "row"]

    connect() {
        this.refresh()
    }

    productChanged() {
        this.refresh()
    }

    actionChanged() {
        this.refresh()
    }

    refresh() {
        const hasProduct = this.hasSelectTarget && this.selectTarget.value !== ""
        const action     = this.hasActionSelectTarget ? this.actionSelectTarget.value : "create_new"

        // Show the action panel only when no product is selected — i.e.
        // when the user is deciding what to do about a brand-new line.
        if (this.hasActionPanelTarget) {
            this.actionPanelTarget.style.display = hasProduct ? "none" : "block"
        }

        // Parent picker only when the chosen action is "add_variant".
        if (this.hasParentPanelTarget) {
            this.parentPanelTarget.style.display = (!hasProduct && action === "add_variant") ? "block" : "none"
        }

        // Dim the whole row when the user picks "skip" so they have a
        // clear visual confirmation the line won't make it onto the order.
        if (this.hasRowTarget) {
            this.rowTarget.style.opacity   = (!hasProduct && action === "skip") ? "0.4" : ""
            this.rowTarget.style.transition = "opacity 0.15s ease"
        }
    }
}
